import Footer from './Footer'

export default Footer



// WEBPACK FOOTER //
// ./src/app/elements/Footer/index.js